// main.js (Vue 2)
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import router from './router'
import './assets/css/global.css' // 引入全局样式
import './assets/icon/iconfont.css' // 引入全局样式
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import i18n from './i18n'
import VueAwesomeSwiper from 'vue-awesome-swiper'

// 配置 Element UI 使用 i18n
import lang from 'element-ui/lib/locale'
lang.i18n((key, value) => i18n.t(key, value))
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})
let language = localStorage.getItem('language') || 'zh-CN'
Vue.prototype.$isZh = language  == 'zh-CN' ? true: false
let isLogin = localStorage.getItem('token')
Vue.prototype.$isLogin = isLogin   ? true: false


// 导入样式
import 'swiper/css/swiper.css'
// 注册组件
Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI);
Vue.use(VueRouter) // ✅ 必须 use VueRouter
new Vue({
  i18n, // ✅ 注入 i18n 实例
  router, // ✅ 注入路由
  render: h => h(App)
}).$mount('#app')


